class ModalDialog extends window.BAO.CustomElement() {
  constructor () {
    super()

    this.setupModal()
    this.trapFocus()
  }

  setupModal () {
    if (!this.els.trigger.element) return

    this.els.trigger.element.addEventListener(
      'click',
      this.handleModalTrigger.bind(this),
    )
    this.externalEls.close.elements.forEach(close => {
      close.addEventListener('click', this.handleModalClose.bind(this))
    })

    this.externalEls.window.elements.forEach(window => {
      window.addEventListener('keydown', e => this.handleKeyDown(e.key))
    })

    this.addEventListener('click', e => {
      if (e.target !== this) return
      this.setAttribute('aria-modal', 'false')
    })
  }

  handleKeyDown (key) {
    if (key === 'Escape' /* ESC */) {
      this.handleModalClose()
    }
  }

  handleModalTrigger () {
    const key = event.target.dataset.modalDialogKey
    this.externalEls.window.elements.forEach(dialogWindow => {
      if (dialogWindow.dataset.modalDialogWindowKey === key) {
        dialogWindow.setAttribute('aria-hidden', 'false')
        dialogWindow.setAttribute('aria-expanded', 'true')
        dialogWindow.querySelector(this.externalEls.close.selector).focus()
      }
    })
  }

  handleModalClose () {
    const key = event.target.dataset.modalDialogCloseKey

    this.externalEls.window.elements.forEach(dialogWindow => {
      if (dialogWindow.dataset.modalDialogWindowKey === key) {
        dialogWindow.setAttribute('aria-hidden', 'true')
        dialogWindow.setAttribute('aria-expanded', 'false')

        if (this.dataset.modalKey === key) {
          this.els.trigger.element.focus()
        }
        window.removeEventListener('keydown', e => this.handleKeyDown(e.key))
      }
    })

    if (key === 'mailing') {
      const customEvent = new CustomEvent('mailingModalClose', {
        bubbles: true,
        detail: {
          key,
        },
      })

      this.dispatchEvent(customEvent)
    }
  }

  trapFocus () {
    const focusableEls = this.externalEls.window.element.querySelectorAll(
      'a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled])',
    )
    const firstFocusableEl = focusableEls[0]
    const lastFocusableEl = focusableEls[focusableEls.length - 1]
    const KEYCODE_TAB = 9

    this.externalEls.window.element.addEventListener('keydown', e => {
      const isTabPressed = e.key === 'Tab' || e.keyCode === KEYCODE_TAB

      if (!isTabPressed) {
        return
      }

      if (e.shiftKey) {
        /* shift + tab */ if (document.activeElement === firstFocusableEl) {
          lastFocusableEl.focus()
          e.preventDefault()
        }
      } /* tab */ else {
        if (document.activeElement === lastFocusableEl) {
          firstFocusableEl.focus()
          e.preventDefault()
        }
      }
    })
  }
}

customElements.define('modal-dialog', ModalDialog)
